import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { pageContext, get, rulesCache, interpolateString } from 'ctm-util-functions';

import { getRuleRangeValues } from '../utils';

import styles from './validation_message.css';

class ValidationMessage extends Component {

    constructor(props) {
        super(props);
        this.validationModel = pageContext.getProps().models.validationModel;
    }

    /**
     * Render a span that contains a validation message if the the element this
     * related to the message has been 'touched' and it's value is invalid.
     * Render an empty span if the element hasn't been touched or has a valid value.
     * @returns {Node} - a span containing the validation error message
     */
    render = () => {
        if (!get(this.props, 'rules.validation')) {
            return null;
        }

        const {
            rules,
            touched,
            position,
            selectedValues,
            manualControl,
            manualVisible,
            manualErrorMessage
        } = this.props;

        // For use if you aren't accessing this component through a schema
        if (manualControl) {
            return (
                <div className={styles.validation_message} style={{ textAlign: position }}>
                    <span className={manualVisible ? styles.error : styles.error_invis} >
                        {manualVisible ? manualErrorMessage : null }
                    </span>
                </div>
            );
        }

        const validation = rules.validation;
        let isElementTouched = touched;
        let elementPosition = position;

        const elementRule = rulesCache.getElementRuleForId(validation.id);
        if (get(elementRule, 'props.touched')) {
            // This is used for standalone validationMessage with no actual formElement that can give a 'touch'.
            isElementTouched = true;
        }

        if (get(elementRule, 'props.position')) {
            elementPosition = get(elementRule, 'props.position');
        }

        const rangeValues = getRuleRangeValues(elementRule, elementRule.props.errorMask);
        const messageState = Object.assign(rangeValues, selectedValues);

        // Default render result - if the element is valid or untouched return an empty span
        let message = null;
        if (isElementTouched && !validation.result) {
            const errorMessage = interpolateString(this.validationModel.getErrorMessage(validation))(messageState);
            if (!errorMessage) {
                // @todo: this is a hack for the multi field address component
                return message;
            }
            message = (
                <div className={styles.validation_message} style={{ textAlign: elementPosition }}>
                    <span className={styles.error}>
                        {errorMessage}
                    </span>
                </div>
            );
        }
        return message;
    };

}

ValidationMessage.propTypes = {
    rules: PropTypes.object,
    touched: PropTypes.bool,
    selectedValues: PropTypes.object,
    position: PropTypes.oneOf(['left', 'center', 'right'])
};

ValidationMessage.defaultProps = {
    position: 'left'
};

export { ValidationMessage };
